import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconFadeIn12 from './IconFadeIn12';
import IconFadeIn16 from './IconFadeIn16';
import IconFadeIn20 from './IconFadeIn20';
import IconFadeIn24 from './IconFadeIn24';
import IconFadeIn32 from './IconFadeIn32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconFadeIn = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconFadeIn12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconFadeIn16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconFadeIn20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconFadeIn24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconFadeIn32 {...props} />}
        </span>
    );
};
IconFadeIn.displayName = 'FondueIconFadeIn';

export default memo(IconFadeIn);
